export default __webpack_public_path__ + "static/media/20s_popup_bg@3x.eeaeb02c.png";